import api from "../utils/APIs/axios";
export const newOperationId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};
export async function basketGet(path, filters = {}) {
  const query = new URLSearchParams(
    Object.entries(filters).filter(([, v]) => v !== "" && v != null),
  ).toString();
  return (await api(`baskets/${path}${query ? `?${query}` : ""}`, "GET")).data;
}
export async function basketPost(path, body) {
  return (await api(`baskets/${path}`, "POST", body)).data;
}
export async function basketExport(kind, filters, format) {
  const query = new URLSearchParams({ ...filters, format }).toString();
  const response = await api(
    `baskets/reports/${kind}?${query}`,
    "GET",
    {},
    { responseType: "blob" },
  );
  const url = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `baskets-${kind}.${format}`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export const errorMessage = (error) =>
  error.response?.data?.message ||
  error.message ||
  "Unable to save. Retry with the same request.";
